module.exports = __webpack_public_path__ + "static/media/21ECLAC43.29bf95d9.jpg";